import { smoothScrollToElement } from "../util/scrollToSection";

export class DeckCalculator {
    activeTooltip: HTMLElement | null;
    private static instance: DeckCalculator;
    static getInstance(): DeckCalculator {
        if (!DeckCalculator.instance) {
            DeckCalculator.instance = new DeckCalculator();
        }
        return DeckCalculator.instance;
    }
    constructor() {
        this.activeTooltip = null;
        this.init();
    }

    public init(): void {
        this.initializeDeckCalculator();
    }

    initializeDeckCalculator() {

        const calculateButton = document.getElementById("calculate-deck");
        const resetButton = document.querySelector(".reset-btn");
        const infoWindow = document.querySelector(".infowindow-container");
        const closeButton = document.querySelector(".info-window-btn");
        const materialResults = document.getElementById("material-results-group");
        // Display info on click fo respective tooltip Icon
        if (materialResults && infoWindow) {
            materialResults.addEventListener("click", (event) => {
                const target = event.target as HTMLElement;
    
                if (target.closest(".info-circle-red")) { // Check if clicked element is or inside .info-circle-red
                    const listItem = target.closest("li");
                    if (listItem?.id) {
                        // Hide the previous tooltip if it exists
                        this.activeTooltip?.classList.add("hidden");
                        const infoText = document.querySelector(`.infowindow-container #${listItem.id}-tooltip`) as HTMLElement;
                        if (infoText) {
                            infoText.classList.remove("hidden");
                            this.activeTooltip = infoText;
                        }
                        infoWindow?.classList.remove("hide-container");
                    }
                }
            });
        }

        // Hide info when clicking the close button
        if (closeButton && infoWindow) {
            closeButton?.addEventListener("click", function () {
                const infoText = document.querySelectorAll(`.infowindow-container .info-window-text`);
                infoText.forEach(p => {
                    if (!p.classList.contains("hidden")) {
                        p.classList.add("hidden");
                    }
                })
                infoWindow?.classList.add("hide-container");
            });
        }

        if (calculateButton) {
            calculateButton.addEventListener("click", (event) => {
                event.preventDefault();
                this.calculateDeckMaterials();
            });
        }

        if (resetButton) {
            resetButton.addEventListener("click", (event) => {
                event.preventDefault();
                this.resetCalculator();
            });
        }
    }

    resetCalculator() {
        const lengthFt = document.getElementById("deck-length-ft") as HTMLInputElement;
        if (lengthFt) lengthFt.value = "";

        const lengthIn = document.getElementById("deck-length-in") as HTMLInputElement;
        if (lengthIn) lengthIn.value = "";

        const widthFt = document.getElementById("deck-width-ft") as HTMLInputElement;
        if (widthFt) widthFt.value = "";

        const widthIn = document.getElementById("deck-width-in") as HTMLInputElement;
        if (widthIn) widthIn.value = "";

        document.querySelector(".calculate-materials-errors")?.classList.add("hidden");

        document.querySelectorAll(".calculated-result .value").forEach(el => el.textContent = "");
        document.querySelectorAll(".calculated-result .sub-text").forEach(el => el.textContent = "");

    }

    calculateDeckMaterials() {
        let lengthFeetValue = parseInt((document.getElementById("deck-length-ft") as HTMLInputElement)?.value) || 0;

        let lengthInchesValue = parseInt((document.getElementById("deck-length-in") as HTMLInputElement)?.value) || 0;
        let widthFeetValue = parseInt((document.getElementById("deck-width-ft") as HTMLInputElement)?.value) || 0;
        let widthInchesValue = parseInt((document.getElementById("deck-width-in") as HTMLInputElement)?.value) || 0;

        let totalLengthInches = lengthFeetValue * 12 + lengthInchesValue;
        let totalWidthInches = widthFeetValue * 12 + widthInchesValue;
        let totalCombinedInches = totalLengthInches * totalWidthInches;

        if (totalLengthInches < 12 || totalWidthInches < 12) {
            document.querySelector(".calculate-materials-errors")?.classList.remove("hidden");
            document.querySelectorAll(".calculated-result .value").forEach(el => el.textContent = "");
            document.querySelectorAll(".calculated-result .sub-text").forEach(el => el.textContent = "");
            return;
        } else {
            document.querySelector(".calculate-materials-errors")?.classList.add("hidden");
        }

        // Material calculations
        let totalDeckingInches = Math.ceil((totalCombinedInches * 1.15) / 5.5);
        let totalLengthAdjusted = 1 + Math.ceil(totalLengthInches / 12 / 8);
        let totalWidthAdjusted = 1 + Math.ceil(totalWidthInches / 12 / 8);
        let returnDecking = Math.ceil(totalDeckingInches / 96);
        let returnBearers = Math.ceil(lengthFeetValue / 8) * (1 + Math.ceil(widthFeetValue / 8));
        let returnJoists = Math.ceil(6 * (totalWidthInches / 12 / 8));
        let returnFootings = totalLengthAdjusted * totalWidthAdjusted;
        let returnBearerBolts = returnFootings * 2;
        let returnJoistHangers = 2 * returnJoists;
        let returnDeckScrews = Math.ceil(350 * (totalCombinedInches / 144 / 100));
        let returnJoistScrews = returnJoists * 4;
        let returnConcrete = returnFootings * 4;
        let returnStain = Math.ceil(totalCombinedInches / 144 / 250);
        // Board size calculation
        let boardSize;

        if (totalLengthInches >= 180) {
            boardSize = 12;
        } else if (totalLengthInches > 144 && totalLengthInches < 180) {
            boardSize = 10;
        } else {
            boardSize = 8;
        }

        // Return values
        let returnValues = {
            decking: returnDecking || 0,
            bearers: returnBearers ? returnBearers * 2 : 0,
            joists: returnJoists || 0,
            footings: returnFootings || 0,
            bolts: returnBearerBolts || 0,
            hangers: returnJoistHangers || 0,
            d_screws: returnDeckScrews || 0,
            j_screws: returnJoistScrews || 0,
            concrete: returnConcrete || 0,
            stain: returnStain || 0,
        };

        Object.entries(returnValues).forEach(([key, value]) => {
            const formattedKey = key.replace("_", "-");
            this.updateResultValue(formattedKey, value);
        });

        this.updateResultNote("joists", lengthFeetValue, lengthInchesValue, boardSize);
        this.updateResultNote("bearers", widthFeetValue, widthInchesValue, boardSize);
        // Smooth scroll to results
        smoothScrollToElement(".material-results");
    }
    updateResultValue(resultIndex: string, value: number | null) {
        let resultElement = document.querySelector(`#material-results-${resultIndex} .value`);
        if (!resultElement) {
            return;
        }
        resultElement.textContent = value !== null ? value.toString() : "0";
    }

    updateResultNote(material: string, feetValue: number, inchesValue: number, boardSize: number) {
        let resultValue = document.querySelector(`#material-results-${material} .sub-text`);

        if (!resultValue) {
            return;
        }
        resultValue.textContent = `${feetValue}' ${inchesValue}", 2x${boardSize}`;
    }

}

document.addEventListener('DOMContentLoaded', () => {
    if (document.querySelector('.deck-calculator-section')) {
        DeckCalculator.getInstance();
    }
});
